import { camelCaseToWords } from "@utils";

export const POLICIES_TABLE_FIELDS = {
  NAME: "policyName",
  STATUS: "status",
  TYPE: "type",
  LINKED_SITES: "linkedSites",
  LINKED_OUTCOMES: "linkedOutcomes",
  LINKED_VISIT_TYPES: "linkedVisitTypes",
  SCENARIOS: "scenarios"
};

export const POLICIES_TABLE_HEADERS = {
  NAME: "Name",
  STATUS: "Status",
  TYPE: "Type",
  LINKED_SITES: "Linked sites",
  LINKED_OUTCOMES: "Linked outcomes",
  LINKED_VISIT_TYPES: "Linked visit types",
  SCENARIOS: "Scenarios"
};

export const LINKED_ITEMS_TYPES = {
  SITES: "sites",
  OUTCOMES: "outcomes",
  VISIT_TYPES: "visitTypes"
};

export const POLICY_TYPES = {
  TRANSFER: "transfer",
  SKILL: "skill",
  SCHEDULING: "scheduling"
};

export const POLICY_TYPE_TO_FILTER_KEY = {
  [POLICY_TYPES.TRANSFER]: "transfer policy",
  [POLICY_TYPES.SKILL]: "skill policy"
};

export const POLICIES_TYPES = {
  SCREENING: "screening",
  SCHEDULING: "scheduling"
};

export const POLICY_TYPES_TOOLTIPS = {
  view: (type) => `View ${camelCaseToWords(type)} filtered by this policy`,
  noItems: (type) => `No ${camelCaseToWords(type)} linked to this policy`,
  nonLinkable: () => "Skill policies cannot be linked to sites"
};

export const MOCK_POLICIES_DATA = [
  {
    id: "policy-1",
    [POLICIES_TABLE_FIELDS.NAME]: "HIPAA Compliance Policy",
    [POLICIES_TABLE_FIELDS.STATUS]: "Live",
    [POLICIES_TABLE_FIELDS.TYPE]: POLICY_TYPES.TRANSFER
  },
  {
    id: "policy-2",
    [POLICIES_TABLE_FIELDS.NAME]: "Emergency Response Protocol",
    [POLICIES_TABLE_FIELDS.STATUS]: "Live",
    [POLICIES_TABLE_FIELDS.TYPE]: POLICY_TYPES.TRANSFER
  },
  {
    id: "policy-3",
    [POLICIES_TABLE_FIELDS.NAME]: "Data Security Guidelines",
    [POLICIES_TABLE_FIELDS.STATUS]: "Draft",
    [POLICIES_TABLE_FIELDS.TYPE]: POLICY_TYPES.TRANSFER
  },
  {
    id: "policy-4",
    [POLICIES_TABLE_FIELDS.NAME]: "Clinical Documentation Standards",
    [POLICIES_TABLE_FIELDS.STATUS]: "Live",
    [POLICIES_TABLE_FIELDS.TYPE]: POLICY_TYPES.SKILL
  },
  {
    id: "policy-5",
    [POLICIES_TABLE_FIELDS.NAME]: "Visitor Access Control",
    [POLICIES_TABLE_FIELDS.STATUS]: "Pending",
    [POLICIES_TABLE_FIELDS.TYPE]: POLICY_TYPES.TRANSFER
  },
  {
    id: "policy-6",
    [POLICIES_TABLE_FIELDS.NAME]: "New Policy Template",
    [POLICIES_TABLE_FIELDS.STATUS]: "Draft",
    [POLICIES_TABLE_FIELDS.TYPE]: POLICY_TYPES.SKILL
  },
  {
    id: "policy-7",
    [POLICIES_TABLE_FIELDS.NAME]: "Skill-Based Routing Policy",
    [POLICIES_TABLE_FIELDS.STATUS]: "Live",
    [POLICIES_TABLE_FIELDS.TYPE]: POLICY_TYPES.SKILL
  }
];

export const POLICIES_TABLE_ROW_ACTIONS = {
  VIEW: "View",
  EDIT: "Edit",
  DUPLICATE: "Duplicate",
  DELETE: "Delete"
};

export const POLICIES_TABLE_TEXT = {
  NO_ROWS_TEXT: "No policies configured yet",
  NO_RESULTS_TEXT: "No policies match your search",
  NO_RESULTS_DESCRIPTION: "Try adjusting your search criteria or filters",
  INFO_TOOLTIP_TEXT: "Policies let you define custom logic for routing and skill selection. Scenarios can refer to caller type, working hours, intent, or language. For example, you might route patients to the on-call desk after hours, route patients and providers to different desks and more.",
  TITLE: "Policies",
  SUBTITLE: "Use policies to define custom logic for routing and skill selection."
};

export const DECISION_TREES_TABLE_TEXT = {
  NO_ROWS_TEXT: "No decision trees configured yet",
  NO_RESULTS_TEXT: "No decision trees match your search",
  NO_RESULTS_DESCRIPTION: "Try adjusting your search criteria or filters",
  INFO_TOOLTIP_TEXT: "Decision trees let you define custom logic for routing and skill selection. Scenarios can refer to caller type, working hours, intent, or language. For example, you might route patients to the on-call desk after hours, route patients and providers to different desks and more.",
  TITLE: "Decision Trees",
  SUBTITLE: "Use decision trees to define custom logic for routing and skill selection."
};

export const getPoliciesTableText = (policiesType) =>
  policiesType === POLICIES_TYPES.SCHEDULING ? DECISION_TREES_TABLE_TEXT : POLICIES_TABLE_TEXT;

export const POLICY_SNACKBAR_SEVERITY = {
  SUCCESS: "success"
};
